// extracted by mini-css-extract-plugin
module.exports = {"header":"_2gc4orGssMqzhZqvWCJW-"};